module.exports = __webpack_public_path__ + "img/caret-down-fill.4146588e.svg";